import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { applicationResource, uploadFile } from './../applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { addApplicationVersion } from './request';
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      headers: {
        'X-Dispatch': 'Upload',
        'X-Version': 'upload'
      },
      action: uploadFile,
      loading: false,
      loading2: false,
      applicationList: [],
      appType: '',
      dataFrom: {
        applicationId: undefined,
        releaseAt: ''
      },
      dialogVisible: false
    };
  },
  computed: {
    dataRule() {
      return {
        applicationId: [{
          required: true,
          message: this.$t('请选择') + this.$t('发布应用'),
          trigger: 'change'
        }],
        versionNumber: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入版本号')
        }],
        platform: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入上线平台')
        }],
        content: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入优化内容')
        }],
        releaseAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('发布日期')
        }]
      };
    }
  },
  methods: {
    init() {
      applicationResource({}).then(res => {
        this.applicationList = res;
      });
      this.dialogVisible = true;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          console.log(this.dataFrom);
          addApplicationVersion(this.dataFrom).then(res => {
            this.$message.success(this.$t('添加成功') + '!');
            this.$emit('cancel');
            this.$emit('ok');
          });
        }
      });
    },
    handleChange(info) {
      console.log(info);
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        let infoObj = process.env.NODE_ENV === 'production' ? cryptoDecrypt(info.file.response.data) : info.file.response.data;
        console.log(infoObj);
        this.dataFrom.apkUrl = infoObj.fileTempUrl;
        // this.from.icon=
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          // this.dataFrom.apkUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    handleChange2(info) {
      console.log(info);
      if (info.file.status === 'uploading') {
        this.loading2 = true;
        return;
      }
      if (info.file.status === 'done') {
        let infoObj = process.env.NODE_ENV === 'production' ? cryptoDecrypt(info.file.response.data) : info.file.response.data;
        console.log(infoObj);
        this.dataFrom.iosUrl = infoObj.fileTempUrl;
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          // = imageUrl;
          this.loading2 = false;
        });
      }
    },
    getInfoFun() {
      let arr = this.applicationList.filter(item => item.applicationId == this.dataFrom.applicationId);
      console.log(arr, 5555);
      this.dataFrom.customerId = arr.length == 0 ? '' : arr[0].customerId;
      this.appType = arr.length == 0 ? '' : arr[0].type;
    }
  }
};